import * as React from 'react'
import type {
    ContainerProps,
    ContainerStaticProperties,
} from './Container.types.ts'
import { cn } from '@core/utils'
import ContainerContent from './ContainerContent'
import ContainerHeader from './ContainerHeader'
import ContainerLeft from './ContainerLeft'
import ContainerRight from './ContainerRight'

const Container: React.FC<ContainerProps> & ContainerStaticProperties = ({
    title,
    goBackProps,
    children,
    ContentProps,
}) => {
    return (
        <div className="lg:min-h-screen lg:bg-semantic-background-primary">
            <ContainerHeader title={title} buttonProps={goBackProps} />
            <div className="lg:container lg:-mt-[109px] lg:pb-10">
                <div
                    {...ContentProps}
                    className={cn(
                        'flex bg-semantic-content-inkInverse lg:rounded-3xl',
                        ContentProps?.className,
                    )}>
                    {children}
                </div>
            </div>
        </div>
    )
}

Container.Content = ContainerContent
Container.Left = ContainerLeft
Container.Right = ContainerRight

export default Container
